// src/contexts/CompetitionContext.jsx

import React, { createContext, useContext, useState } from "react";

// 1. Create the context itself
export const CompetitionContext = createContext(undefined);

// 2. Provider component (wraps children in context)
export const CompetitionProvider = ({ children }) => {
  // Holds the current competition object (can be null before loaded)
  const [competition, setCompetition] = useState(null);

  return (
    <CompetitionContext.Provider value={{ competition, setCompetition }}>
      {children}
    </CompetitionContext.Provider>
  );
};

// 3. Convenience hook for using the context
export const useCompetition = () => {
  const ctx = useContext(CompetitionContext);
  if (!ctx) {
    throw new Error(
      "useCompetition must be used within a CompetitionProvider"
    );
  }
  return ctx;
};